export const MarketActivityBanner = ({ uniqueCount = 139 }) => (
  <section className="section-shell pt-4" data-testid="landing-market-activity-banner-shell">
    <div className="rounded-full border border-[#001935]/10 bg-white/90 px-5 py-3 text-center text-xs font-bold uppercase tracking-[0.18em] text-[#42566f] shadow-[0_12px_30px_rgba(0,25,53,0.08)]" data-testid="landing-market-activity-banner">
      Monitoring thousands of active market signals across {uniqueCount} exclusive unique opportunities.
    </div>
  </section>
);